import DOMPurify from 'dompurify';

const transactionDescriptionConfig = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: [
    'script',
    'style',
    'iframe',
    'object',
    'embed',
    'form',
    'input',
    'button',
    'textarea',
    'select',
    'option',
    'link',
    'meta'
  ],
  FORBID_ATTR: ['style']
};

export function sanitizeTransactionDescription(value) {
  return DOMPurify.sanitize(String(value || ''), transactionDescriptionConfig);
}
